import React, { useState, useEffect } from 'react';
import { MatrixQuestion } from '../../survey-tools/likert-scales';
import { shuffleArray } from '../../survey-tools/shuffle-and-sample'; // Import shuffleArray
import { Button } from '@mui/material';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import { Typography} from "@mui/material";
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed

function Brooding({ instanceId,nextTask }) {
    const [showDialog, setShowDialog] = useState(false);
    const [shuffledStatements, setShuffledStatements] = useState([]);
    const [responses, setResponses] = useState(Array(5).fill(-99)); 

    useEffect(() => {
        const statements = [
        "Think 'Why do I always react this way?'",
        "Think 'Why can't I handle things better?'",
        "Think about all your shortcomings, failings, faults, mistakes.",
        "Think 'Why can't I get going?'",
        "Think 'What am I doing to deserve this?'",
    ];
        setShuffledStatements(shuffleArray(statements));
    }, []) // Empty dependency array to only run once on mount

    const options = ["Almost Never", "Sometimes", "Often", "Almost Always"];
    
    const statementKeyMap = {
    "Think 'Why do I always react this way?'": "brooding_1",
    "Think 'Why can't I handle things better?'": "brooding_2",
    "Think about all your shortcomings, failings, faults, mistakes.": "brooding_3",
    "Think 'Why can't I get going?'": "brooding_4",
    "Think 'What am I doing to deserve this?'": "brooding_5"
};


    const handleNextClick = () => {
    const isComplete = responses.every(val => val !== -99);
    if (!isComplete) {
        setShowDialog(true);
    } else {
        const broodingRatings = {};
        shuffledStatements.forEach((statement, index) => {
            const key = statementKeyMap[statement];
            broodingRatings[key] = responses[index];
        });

        nextTask({ data: { brooding: broodingRatings } });
        console.log(broodingRatings);
    }
    };

    return (
        <PageContainer>

        <div>

            <MatrixQuestion
                title=<Typography gutterBottom>People think and do many different things when they feel depressed. Please read each of the items below and indicate whether you almost never, sometimes, often, or almost always think or do each one when you feel down, sad, or depressed. Please indicate what you generally do, not what you think you should do.</Typography>
                rows={shuffledStatements}
                columns={options}
                handleUpdate={(data) => setResponses(data)}
            />
            <Button variant="contained" onClick={handleNextClick}>Next</Button>

            <CustomConfirmationDialog
                open={showDialog}
                onClose={() => setShowDialog(false)}
                onConfirm={() => {
                    setShowDialog(false);
                    const broodingRatings = {};
        shuffledStatements.forEach((statement, index) => {
            const key = statementKeyMap[statement];
            broodingRatings[key] = responses[index];
        });

        nextTask({ data: { brooding: broodingRatings } });
        console.log(broodingRatings);
                }}
            />
            
        </div>
        </PageContainer>

    );
};

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(Brooding);

